export const odinQuickReference = [
  {
    id: 'qr-round',
    title: 'Runda',
    requiredModuleIds: ['base'],
    items: [
      'Nowy wiking (jeśli tor).',
      'Żniwa, jeśli wskazane.',
      'Wzgórza i broń zgodnie z torem.',
      'Faza akcji (kolumna = koszt wikingów; pas kończy udział; pierwszy pas = znacznik pierwszego gracza).',
      'Pierwszy gracz.',
      'Dochód (widoczny symbol + ciągłość).',
      'Rozmnażanie (jeden krok na rodzaj).',
      'Biesiada (zakryj stół albo kara; żywność wraca).',
      'Premie (otoczony + odkryty symbol).',
      'Porządki końca rundy.',
    ],
  },
  {
    id: 'qr-placement',
    title: 'Układanie kafli',
    requiredModuleIds: ['base'],
    items: [
      'Kafel mieści się w siatce i nie nachodzi na inne elementy.',
      'Można obracać, ale nie odwracać bez ulepszenia.',
      'Czerwone i pomarańczowe dobra nie stykają się bokami (rogi OK).',
      'Srebro wypełnia pojedyncze pola.',
      'Symbol premii i dochodu pozostaje odkryty.',
      'Zakrycie minusa usuwa karę — nie dodaje punktów.',
    ],
  },
  {
    id: 'qr-actions',
    title: 'Rodziny akcji',
    requiredModuleIds: ['base'],
    items: [
      'Góry/wzgórza: kolejne zasoby z paska, nie ze środka.',
      'Pułapki i polowanie: tylko modyfikatory z ikony pola.',
      'Wielorybnictwo: wymaga wielorybnika.',
      'Militarne: zwykle langskip; żeton o wartości miecza ≤ wynik.',
      'Nazwy Najazd / Plądrowanie / Rabunek / Grabież nie są zamienne.',
      'Emigracja usuwa łódź; ruda na niej zwykle przepada.',
    ],
  },
  {
    id: 'qr-norwegians',
    title: 'Norwegowie',
    requiredModuleIds: ['base', 'norwegians'],
    items: [
      'Trzy plansze dodatku; bez żetonów powtórzeń 4-graczy.',
      'Piąta kolumna kończy twoją fazę akcji.',
      '2 wikingów w 5. kolumnie: dodatkowo zagraj pomocnika.',
      'Świnie: przy co najmniej 2 otrzymaj 1 nową (bez ciąży).',
      'Klacze rozmnażają się jak owce i krowy.',
      'Grabież wymaga knary; bez kamieni; ≠ Najazd.',
      'Mała emigracja usuwa wielorybnik i jego rudę.',
      'Szopa rzemieślnicza jest szopą, ale nie domem.',
      'Żeton PZ: zamiast zagrania pomocnika; bierz najwyższy dostępny.',
    ],
  },
  {
    id: 'qr-solo',
    title: 'Solo',
    requiredModuleIds: ['base', 'solo'],
    items: [
      'Dwa zestawy wikingów naprzemiennie.',
      'Użyte w tej rundzie blokują następną.',
      'Cel: maksymalizacja wyniku przy tej samej konfiguracji.',
    ],
  },
] as const;
